// extracted by mini-css-extract-plugin
export var details = "PageBanner-module--details--af458";
export var detailsContainer = "PageBanner-module--detailsContainer--8de05";
export var pageBanner = "PageBanner-module--pageBanner--c2e56";
export var priceReviewContainer = "PageBanner-module--priceReviewContainer--2008e";
export var title = "PageBanner-module--title--a1ff8";